import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import "./LanguageToggle.css";

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      className="language-toggle"
      onClick={toggleLanguage}
      title={`Switch to ${language === "english" ? "Amharic" : "English"}`}
    >
      <span className="language-text">
        {language === "english" ? "አ" : "EN"}
      </span>
    </button>
  );
};

export default LanguageToggle;
